import { render, staticRenderFns } from "./CloseMyAccount.vue?vue&type=template&id=59292c3a"
import script from "./CloseMyAccount.vue?vue&type=script&lang=js"
export * from "./CloseMyAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports